import * as React from 'react';
import { BubbleLoader } from '../Common/BubbleLoader';
import styles from './OnlineChat.module.scss';

const LoadingPlaceholder: React.FC<IProps> = (props) => {
    if (!props.show) {
        return null;
    }

    return (
      <div className={styles.loading}>
          <BubbleLoader />
          Не закрывайте это окно и ожидайте подключения эксперта для итоговой проверки и допуска к экзамену
      </div>
    );
};

interface IProps {
    show?: boolean;
}

export default LoadingPlaceholder;
